import React from 'react';
import baseCopy from './tnc/us';

export interface textProps {
    title: string;
    content: string[];
}

const useTNC = (locale: string) => {
    const [maps, setMaps] = React.useState<textProps | null>(null);

    React.useEffect(() => {
        (async () => {
            try {
                const module = await import(`./tnc/${locale}.ts`);
                setMaps(module.default || {});
            } catch (error) {
                console.error(`Failed to load ${locale}`, error);
                setMaps(baseCopy);
            }
        })();
    }, [locale]);

    return maps;
};

export default useTNC;
